export default __webpack_public_path__ + "static/media/iconGridActive.0e67d664.svg";